import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { EmptyString, FormTypeAdd, FormTypeEdit, MdrOffUs, MdrOnUs, MdrQrisOffUs, MdrQrisOnUs, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import moment from "moment"
import { decimal, GetStatus, money, removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import DatePicker from "components/Input/DatePicker"
import { useModal } from "context/ModalContext"
import { useCallApi } from "api/apiHooks"
import { FormCard, PagesFormTitle } from "components/Cards"

export default function TransactionReportFormModal({ isOpen, onClose, data, transactionId }) {
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchUpdateTransaction, fetchTransactionById, fetchCustomerCardList, fetchEdcList, fetchLocationList } = useCallApi()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")

    const [amount, setAmount] = useState(EmptyString)
    const [trMdr, setTrMdr] = useState(EmptyString)
    const [netto, setNetto] = useState(EmptyString)
    const [transactionType, setTransactionType] = useState(MdrOnUs);
    const [mdrEdcOnUs, setMdrEdcOnUs] = useState(EmptyString)
    const [mdrEdcOffUs, setMdrEdcOffUs] = useState(EmptyString)
    const [mdrQrisOnUs, setMdrQrisOnUs] = useState(EmptyString)
    const [mdrQrisOffUs, setMdrQrisOffUs] = useState(EmptyString)
    const [transactionDate, setTransactionDate] = useState(null)
    const [customerCard, setCustomerCard] = useState(EmptyString)
    const [customerCardOptions, setCustomerCardOptions] = useState([])
    const [edcData, setEdcData] = useState([])
    const [edc, setEdc] = useState(EmptyString)
    const [edcOptions, setEdcOptions] = useState([])
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    const [timeHour, setTimeHour] = useState(EmptyString)
    const [timeMinute, setTimeMinute] = useState(EmptyString)
    const [locationOptions, setLocationOptions] = useState([])
    const [selectedLocation, setSelectedLocation] = useState(null)
    const [errorMdrOff, setErrorMdrOff] = useState(false)
    
    const customerCardOnInput = (e) => {
        fetchCustomerCardList(e, '', 0, 0, '1', 50, 0).then((res) => {
            if (!res) return
        })
    }
    const customerCardChange = (e) => {
        setCustomerCard(e)
    }
    const edcChange = (e) => {
        setEdc(e)
        
        if (edcData.length > 0){
            for(let i=0; i < edcData.length; i++){
                if(edcData[i].edcId == e.value){
                    setMdrEdcOffUs(edcData[i].mdrOff)
                    setMdrEdcOnUs(edcData[i].mdrOn)
                    setMdrQrisOnUs(edcData[i].mdrQrisOn)
                    setMdrQrisOffUs(edcData[i].mdrQrisOff)
                }
            }
        }
    }
    const handleChange = (event) => {
        setTransactionType(event.target.value);
    }
    const amountChange = (e) => {
            fCalculateNetto(e.target.value, trMdr)
            setAmount(money(e.target.value))        
    }
    const trMdrChange = (e) => {
        let inputValue = e.target.value

        if (inputValue !== EmptyString){
            let number = parseInt(inputValue)
            if (number > 100){
                
            }else{
                setTrMdr(decimal(e.target.value))
            }
        }else{
            setTrMdr(decimal(e.target.value))
        }
        
        
    }
    const trMdrKeyUp = (e) => {
        fCalculateNetto(amount, e.target.value)
    }

    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try {
                    let trxType = ''

                    if (transactionType === MdrOnUs){
                        trxType = "1"
                    } else if (transactionType === MdrOffUs){
                        trxType = "2"
                    } else if (transactionType === MdrQrisOnUs){
                        trxType = "3"
                    } else if (transactionType === MdrQrisOffUs){
                        trxType = "4"
                    } else {
                        trxType = ""
                    }

                    let time = (timeHour === EmptyString ? "00" : timeHour) + ":" + (timeMinute === EmptyString ? "00" : timeMinute)

                    const res = await fetchUpdateTransaction(
                        transactionId, 
                        customerCard.value,
                        moment(transactionDate).format('yyyy-MM-DD'),
                        edc.value,
                        mdrEdcOffUs, 
                        mdrEdcOnUs, 
                        mdrQrisOnUs, 
                        mdrQrisOffUs, 
                        trxType, 
                        amount.replaceAll(',', ''), 
                        trMdr, 
                        netto.replaceAll(',', ''),
                        time,
                        selectedLocation.value
                    )

                    if (!res) return
                } finally {
                    hideLoading()
                }
                
                showSuccess({
                    onSuccess: () => {
                        onClose()
                    }
                })
            }
        }
    }
    const deleteBtnClick = () => {
        
    }
    const backBtnClick = () => {
        onClose()
    }

    function validateForm(){
        let errorCount = 0

        // if (bankId === EmptyString){
        //     setErrorBankId(true)
        //     errorCount++
        // }else{
        //     setErrorBankId(false)
        // }

        // if (edcName === EmptyString){
        //     setErrorEdcName(true)
        //     errorCount++
        // }else{
        //     setErrorEdcName(false)
        // }

        // if (beneficiaryAccountNo === EmptyString){
        //     setErrorBeneficiaryAccountNo(true)
        //     errorCount++
        // }else{
        //     setErrorBeneficiaryAccountNo(false)
        // }

        // if (mdrOn === EmptyString){
        //     setErrorMdrOn(true)
        //     errorCount++
        // }else{
        //     setErrorMdrOn(false)
        // }

        // if (mdrOff === EmptyString){
        //     setErrorMdrOff(true)
        //     errorCount++
        // }else{
        //     setErrorMdrOff(false)
        // }

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fCalculateNetto(amount, mdrInput){
        let xAmount = amount === EmptyString ? 0 : parseFloat(amount.replaceAll(",", ""))
        let xMdr = mdrInput === EmptyString ? 0 : parseFloat(mdrInput)
        let xNetto = xAmount - (xAmount * xMdr / 100)
        setNetto(money(parseInt(xNetto)))
    }

    useEffect(() => {
        showLoading()

        try {
            fetchLocationList('', '1', 500, 0).then((res) => {
                if (!res) return 
                
                let data = res.data.listData

                if (data.length > 0){
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].locationName, value: String(data[i].locationId) })
                    }

                    setLocationOptions(tempArray)
                }

                fetchCustomerCardList('', '', 0, 0, '1', 50, 0).then((res) => {
                    if (!res) return

                    let data = res.data.listData

                    if (data.length > 0){
                        let tempArray = []

                        for (let i = 0; i < data.length; i++){
                            tempArray.push({ label: data[i].cardNumber + " - " + data[i].customerName, value: String(data[i].customerCardId) })
                        }

                        setCustomerCardOptions(tempArray)
                    }

                    fetchEdcList('', '', '', '', '1', 500, 0).then((res) => {
                        if (!res) return 

                        let data = res.data.listData

                        if (data.length > 0){
                            setEdcData(data)
                            let tempArray = []

                            for (let i = 0; i < data.length; i++){
                                tempArray.push({ label: data[i].bankCode + " - " + data[i].edcName.toUpperCase(), value: String(data[i].edcId) })
                            }

                            setEdcOptions(tempArray)
                            setEdc(tempArray[0].value)
                        }

                        fetchTransactionById(transactionId).then((res) => {
                            if (!res) return 

                            let data = res.data

                            setMdrEdcOnUs(data.mdrEdcOnUs)
                            setMdrEdcOffUs(data.mdrEdcOffUs)
                            setMdrQrisOnUs(data.mdrQrisOnUs)
                            setMdrQrisOffUs(data.mdrQrisOffUs)
                            setCustomerCard({ label: data.customerCardNumber + ' - ' + data.customerName, value: String(data.customerCardId) })
                            setTransactionDate(data.transactionDate)
                            setEdc({label: data.bankCode + ' - ' + data.edcName, value: String(data.edcId)})
                            setAmount(money(data.amount))
                            if (data.type === "1"){
                                setTransactionType(MdrOnUs)
                            } else if (data.type === "2"){
                                setTransactionType(MdrOffUs)
                            } else if (data.type === "3"){
                                setTransactionType(MdrQrisOnUs)
                            } else if (data.type === "4"){
                                setTransactionType(MdrQrisOffUs)
                            }
                            setTrMdr(data.mdr)
                            setNetto(money(data.netto))
                            setStatus(data.status)
                            setCreateDate(moment(data.createDate).format('DD MMM yyyy'))
                            setUpdateDate(moment(data.updateDate).format('DD MMM yyyy'))
                            setUpdateBy(data.updateBy)
                            setSelectedLocation({ label: data.locationName, value: String(data.locationId) })

                            if (data.time !== null && data.time !== EmptyString){
                                let timeParts = data.time.split(':')
                                setTimeHour(timeParts[0])
                                setTimeMinute(timeParts[1])
                            }
                        })
                    })
                })
            })
        } finally {
            hideLoading()
        }
    }, [])

    return (
        <div className="fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center z-30 rounded-lg">
            <div className='z-30 bg-white w-full h-full xl:h-auto xl:w-3/4 2xl:w-1/2 overflow-y-auto shadow-lg rounded-lg p-8'>
                <PagesFormTitle 
                    title={'Detail Transaksi'}
                    formType={formType}
                    status={status}
                    createDate={createDate}
                    updateDate={updateDate}
                    updateBy={updateBy}
                />

                <div className="mt-5 flex flex-col gap-3">
                    <FormCard title='Nama Pelanggan' width={'w-full sm:w-[560px]'}>
                        <Select options={customerCardOptions} value={customerCard} onInputChange={customerCardOnInput} onChange={customerCardChange} />
                    </FormCard>

                    <FormCard title='Tanggal Transaksi'>
                        <DatePicker className="w-full h-10 bg-white" value={transactionDate} onChange={setTransactionDate} />
                    </FormCard>

                    <FormCard title='EDC'>
                        <Select options={edcOptions} value={edc} onChange={edcChange} />
                    </FormCard>

                    <FormCard title='Tipe Transaksi' width={'w-full sm:w-[400px]'}>
                        <div className="flex gap-2 w-full sm:w-[400px]">
                            <label className="flex gap-2">
                                <input type="radio" value={MdrOnUs} checked={transactionType === MdrOnUs} onChange={handleChange} />
                                On Us
                            </label>
                            <label className="flex gap-2">
                                <input type="radio" value={MdrOffUs} checked={transactionType === MdrOffUs} onChange={handleChange} />
                                Off Us
                            </label>
                            <label className="flex gap-2">
                                <input type="radio" value={MdrQrisOnUs} checked={transactionType === MdrQrisOnUs} onChange={handleChange} />
                                Qris On Us
                            </label>
                            <label className="flex gap-2">
                                <input type="radio" value={MdrQrisOffUs} checked={transactionType === MdrQrisOffUs} onChange={handleChange} />
                                Qris Off Us
                            </label>
                        </div>
                    </FormCard>

                    {/* Transaction Time */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Transaction Time</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="flex gap-2 items-center">
                                    <div className="w-14">
                                        <input className="input" 
                                            value={timeHour} 
                                            onChange={(e) => e.target.value.length > 2 ? null : setTimeHour(removeNonNumeric(e.target.value)) } 
                                            placeholder="HH"
                                        />
                                    </div>
                                    <span>:</span>
                                    <div className="w-14">
                                        <input className="input" 
                                            value={timeMinute} 
                                            onChange={ (e) => e.target.value.length > 2 ? null : setTimeMinute(removeNonNumeric(e.target.value)) } 
                                            placeholder="MM"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorMdrOff ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Mdr Off Us is required!</span>
                        </div>
                    </div>

                    <FormCard title='Jumlah Gesek'>
                        <input className="input" value={amount} onChange={amountChange} />
                    </FormCard>

                    <FormCard title='MDR'>
                        <input className="input" value={trMdr} onChange={trMdrChange} onKeyUp={trMdrKeyUp} />
                    </FormCard>

                    <FormCard title='Uang Diterima'>
                        <input className="input" value={netto} disabled={true} />
                    </FormCard>

                    <FormCard title='Lokasi'>
                        <Select 
                            options={locationOptions} 
                            value={selectedLocation} 
                            onChange={setSelectedLocation}
                        />
                    </FormCard>
                </div>
                    

                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                    <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                    <button
                        className="bg-black hover:bg-gray-600 text-white py-2 px-4 rounded-md"
                        onClick={backBtnClick}
                    >
                        <span>Close</span>
                    </button>
                </div>
            </div>

            <div className="fixed top-0 bottom-0 left-0 right-0 bg-app-matte-black opacity-60 z-20" />
        </div>
    )
}